
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5530',
  depVersions: {
  "data-privacy-request-ui": "static-1.5530",
  "data-fetching-client": "static-1.9675",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8018",
  "hub-http-shared-msw-handlers": "static-1.9964",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11477",
  "I18n": "static-7.1628",
  "jasmine-runner": "static-1.6469",
  "privacy-center-public-service-types": "static-1.4793",
  "quartz": "static-1.7039",
  "react-dlb": "static-1.79",
  "ui-components-test-utils": "static-1.5614",
  "UIComponents": "static-3.8423",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.86",
  "foundations-assets": "static-1.4870",
  "foundations-components": "static-1.7941",
  "foundations-components-test-utils": "static-1.5424",
  "foundations-theming": "static-1.4423",
  "hub-http": "static-1.6226",
  "quartz-config": "static-1.817",
  "quartz-core": "static-1.6258",
  "quartz-routing": "static-1.469",
  "quick-fetch": "static-1.3920",
  "raven": "static-3.5925",
  "react": "static-7.186",
  "react-rhumb": "static-1.16678",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11155",
  "usage-tracker": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "usage-tracker-anonymous": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "usage-tracker-core": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3402",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3316",
  "quartz-webpack": "static-1.3263",
  "bend-plugin-quartz-routing": "static-1.117",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.82",
  "HeadJS": "static-2.762",
  "framer-motion": "static-1.72",
  "hs-test-utils-bend-plugin": "static-1.3129",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "ts-schema": "static-1.4083",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "react-utils": "static-2.5348",
  "StyleGuideUI": "static-3.487",
  "jasmine": "static-4.4333",
  "rpc-client-utils": "static-1.4657",
  "HubStyle": "static-2.11784",
  "ui-addon-draggable": "static-3.4768",
  "cssUtils": "static-1.794",
  "hs-story-utils": "static-1.9429",
  "icons": "static-2.647",
  "react-select-plus": "static-1.105",
  "react-virtualized": "static-2.99",
  "ui-images": "static-2.1156",
  "bend-plugin-foundations-components": "static-1.4210",
  "floating-ui": "static-1.56",
  "foundations-theming-specialty": "static-1.2139",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.26",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.1957",
  "ui-fonts": "static-1.739",
  "foundations-components-legacy": "static-1.966",
  "bend-plugin-foundations-theming": "static-1.2906",
  "foundations-theming-base": "static-1.3408",
  "stylex": "static-1.33",
  "hs-locale-management": "static-1.83",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.836",
  "hubspotter-http": "static-1.4655",
  "mobile-manifest-mixins": "static-1.536",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.714",
  "quartz-head": "static-1.704",
  "quartz-i18n": "static-1.714",
  "quartz-test": "static-1.714",
  "quartz-tracking": "static-1.418",
  "usage-tracker-container": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "csstype": "static-1.50",
  "web-vitals": "static-1.5",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3205",
  "bend-plugin-chirp-manifest": "static-1.67",
  "chirp-fetch": "static-1.1893",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.70",
  "sassPrefix": "static-1.156",
  "hubspotter-http-shared-msw-handlers": "static-1.9962",
  "usage-tracker-session-replay": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5530",
  "data-fetching-client": "/data-fetching-client/static-1.9675",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8018",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9964",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11477",
  "I18n": "/I18n/static-7.1628",
  "jasmine-runner": "/jasmine-runner/static-1.6469",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4793",
  "quartz": "/quartz/static-1.7039",
  "react-dlb": "/react-dlb/static-1.79",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5614",
  "UIComponents": "/UIComponents/static-3.8423",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.86",
  "foundations-assets": "/foundations-assets/static-1.4870",
  "foundations-components": "/foundations-components/static-1.7941",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5424",
  "foundations-theming": "/foundations-theming/static-1.4423",
  "hub-http": "/hub-http/static-1.6226",
  "quartz-config": "/quartz-config/static-1.817",
  "quartz-core": "/quartz-core/static-1.6258",
  "quartz-routing": "/quartz-routing/static-1.469",
  "quick-fetch": "/quick-fetch/static-1.3920",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.186",
  "react-rhumb": "/react-rhumb/static-1.16678",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11155",
  "usage-tracker": "/usage-tracker/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "usage-tracker-core": "/usage-tracker-core/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3402",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3316",
  "quartz-webpack": "/quartz-webpack/static-1.3263",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.117",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.82",
  "HeadJS": "/HeadJS/static-2.762",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3129",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "ts-schema": "/ts-schema/static-1.4083",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "react-utils": "/react-utils/static-2.5348",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "jasmine": "/jasmine/static-4.4333",
  "rpc-client-utils": "/rpc-client-utils/static-1.4657",
  "HubStyle": "/HubStyle/static-2.11784",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4768",
  "cssUtils": "/cssUtils/static-1.794",
  "hs-story-utils": "/hs-story-utils/static-1.9429",
  "icons": "/icons/static-2.647",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-virtualized": "/react-virtualized/static-2.99",
  "ui-images": "/ui-images/static-2.1156",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4210",
  "floating-ui": "/floating-ui/static-1.56",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2139",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.26",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.1957",
  "ui-fonts": "/ui-fonts/static-1.739",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.966",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2906",
  "foundations-theming-base": "/foundations-theming-base/static-1.3408",
  "stylex": "/stylex/static-1.33",
  "hs-locale-management": "/hs-locale-management/static-1.83",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.836",
  "hubspotter-http": "/hubspotter-http/static-1.4655",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.536",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.714",
  "quartz-head": "/quartz-head/static-1.704",
  "quartz-i18n": "/quartz-i18n/static-1.714",
  "quartz-test": "/quartz-test/static-1.714",
  "quartz-tracking": "/quartz-tracking/static-1.418",
  "usage-tracker-container": "/usage-tracker-container/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.5",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3205",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.67",
  "chirp-fetch": "/chirp-fetch/static-1.1893",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.70",
  "sassPrefix": "/sassPrefix/static-1.156",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9962",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
